import { CROP_TYPE_FCPO, CropFCPO, OTHER_REDZONE_EXCEPTION_KEY, RedzoneException } from "models";

type RedzoneExceptionDetails = { reason: string; explanation: string | null };

export const getRedzoneExceptionDetails = (
  crop: CropFCPO,
  isFieldInRedzone: boolean,
  redzoneExceptions: RedzoneException[] | undefined
): RedzoneExceptionDetails | null => {
  if (!redzoneExceptions || !isFieldInRedzone || crop.cropType !== CROP_TYPE_FCPO.COVER || crop.mandatory !== false || !crop.redzoneExceptionId) {
    return null;
  }

  const selectedException = redzoneExceptions.find((exception) => exception.id === crop.redzoneExceptionId);
  const isOtherReason = selectedException?.key === OTHER_REDZONE_EXCEPTION_KEY;

  return {
    reason: selectedException?.description ?? "Unknown reason",
    explanation: isOtherReason ? crop.redzoneExceptionExplanation ?? null : null,
  };
};
